import { graphql } from "gatsby";
import { GatsbyImage } from "gatsby-plugin-image";
import React from "react";
import { CategoryCardCategoryFragment } from "../../../../graphql-types";
import InternalLink from "../../../components/InternalLink";
import { trackCustomEvent } from "../../../utilities/analytics";
import { BackgroundImage } from "./BackgroundImage";

type Props = {
  category: CategoryCardCategoryFragment;
};

export function CategoryCard({
  category: { hero, title, heroOverlay, path, ctaMicrocopy, shortDescription },
}: Props) {
  return (
    <BackgroundImage.Container>
      {hero && (
        <GatsbyImage
          image={hero.gatsbyImageData}
          alt={hero.description || ""}
          style={BackgroundImage.style}
        />
      )}
      <BackgroundImage.Overlay className="flex flex-col p-6">
        <p className="text-white font-black font-montserrat text-center text-5xl uppercase leading-none mb-6">
          {title}
        </p>
        {heroOverlay && (
          <GatsbyImage
            alt={heroOverlay.description || ""}
            className="mx-auto mb-6"
            image={heroOverlay.gatsbyImageData}
          />
        )}
        <p className="text-white font-bold text-center text-lg mt-auto mb-6 leading-tight">
          {shortDescription}
        </p>
        <InternalLink
          className={
            "p-4 mx-auto bg-white text-center text-xl font-openSans transition-all rounded-sm text-persil-blue-500 leading-none min-w-48 hover:text-persil-blue-500 focus:text-persil-blue-500 active:bg-gray-300 hover:translate-y-[-3px]"
          }
          onClick={() => {
            trackCustomEvent({
              action: "Link Click",
              category: "Engagement",
              label: path,
            });
          }}
          href={path}
        >
          {ctaMicrocopy}
        </InternalLink>
      </BackgroundImage.Overlay>
    </BackgroundImage.Container>
  );
}

export const fragments = {
  category: graphql`
    fragment CategoryCardCategory on SustainabilityCategory {
      path
      title
      ctaMicrocopy
      shortDescription
      hero {
        description
        gatsbyImageData(layout: FULL_WIDTH)
      }
      heroOverlay {
        description
        gatsbyImageData(layout: FIXED, height: 224)
      }
    }
  `,
};
